var exports = {
  "Qs": "x9245d464--429534--content",
  "MZ": "x9245d464--429534--factoid-list",
  "s5": "x9245d464--429534--factoid-title-wrapper",
  "Hn": "x9245d464--429534--text-list",
};

module.exports = exports;
